import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";

export function useQueryURL<T>() {
    const { search } = useLocation();

    const urlParams = useMemo(() => {
        const urlParams = new URLSearchParams(search);
        return urlParams;
    }, [search]);

    /**
      * Return a object with the keys declared on arguments
      * @description This function can be used when you want to retrieve search params. 
      * When defining a type of the object you want to return (through generic), this function will return an object containing the keys informed in the parameters and the value of each key will be the value corresponding to the key in the search params, if any. 
      * @param keys Key list of properties that you want to be returned on the object
      * 
      * @returns An object with the properties declared on the param keys with same type informed when called this hook
      * @example 
      * //with an url: **?name=Shipeezi&age=90
      * import useQueryURL from "./useQueryURL";
      * const objectBasedOnSearchParams = useQueryURL<{name?: string, age?: string}>("name", "age");
      * console.log(objectBasedOnSearchParams) > {name: "Shipeezi", age: "90"}
      */
    function get(...keys: Array<keyof T>) {
        const object = {} as T;
        keys.forEach(key => {
            object[key] = (urlParams.get(key as string) as any) as T[keyof T];
        });
        return object;
    }

    return get
}

export default useQueryURL;